var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 44,
    viewBox: "0 0 59 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.624 43.8318C48.7062 43.8318 58.5009 34.0198 58.5009 21.9159C58.5009 9.81209 48.7062 0 36.624 0C24.5417 0 14.7471 9.81209 14.7471 21.9159C14.7471 34.0198 24.5417 43.8318 36.624 43.8318Z",
    fill: "#0AE8F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3331 11.5524C15.6685 14.6492 14.7471 18.1629 14.7471 21.9148C14.7471 25.6667 15.6982 29.1804 17.3331 32.2772L22.6239 29.0613L34.365 21.9148L22.6239 14.7683L17.3331 11.5524Z",
    fill: "#006BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7431 21.9157C14.7431 18.1638 15.6943 14.6501 17.3291 11.5533L10.879 7.62268V16.2283H0V27.6031H10.879V36.2087L17.3291 32.2781C15.6646 29.1813 14.7431 25.6676 14.7431 21.9157Z",
    fill: "#BDCCD4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.e20db8604eb7470791e8ac7d5724af31.svg";
export { ForwardRef as ReactComponent };